import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CartItem, CartState } from "../types";

const initialState: CartState = {
    items: [],
};

const cartSlice = createSlice({
    name: "cart",
    initialState,
    reducers: {
        addItem: (state, action: PayloadAction<CartItem>) => {
            state.items.push(action.payload);
        },
        removeItem: (state, action: PayloadAction<CartItem>) => {
            const itemIndex = state.items.findIndex(
                (item) => item.id === action.payload.id
            );
            if (itemIndex !== -1) {
                state.items.splice(itemIndex, 1);
            }
        },
        clearItems: (state) => {
            state.items = [];
        },
    },
});

export const { addItem, clearItems, removeItem } = cartSlice.actions;
export default cartSlice.reducer;
